import { Instagram } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";

const TikTok = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const normalize = (url) => {
  const u = (url || "").trim();
  if (!u) return "";
  return /^https?:\/\//i.test(u) ? u : `https://${u}`;
};

export const useSocialLinks = () => {
  const { homepage } = useCurrency();
  return [
    { key: "instagram", label: "Instagram", href: normalize(homepage?.instagram_url), Icon: Instagram },
    { key: "tiktok", label: "TikTok", href: normalize(homepage?.tiktok_url), Icon: TikTok },
  ].filter((s) => s.href);
};

export const SocialIcons = ({ links, size = 24, linkClass, testPrefix }) => (
  <div className="flex gap-5 text-white/70">
    {links.map(({ key, label, href, Icon }) => (
      <a key={key} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
        data-testid={`${testPrefix}-${key}`} className={linkClass}>
        {key === "instagram" ? <Icon strokeWidth={1.3} size={size} /> : <Icon size={size - 2} />}
      </a>
    ))}
  </div>
);
